import { Flex, Group, Pill, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { DoctoralCommitteeValidationAction } from '@/module/Author/DoctoralCommittee/Validation/DoctoralCommitteeValidationAction';
import { DoctoralCommitteeValidationHistory } from '@/module/Author/DoctoralCommittee/Validation/DoctoralCommitteeValidationHistory';
import { DoctoralCommitteeDeleteButton } from '@/module/Author/DoctoralCommittee/components/DoctoralCommitteeDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { DoctoralCommitteeProofAction } from './Proof';
import { DoctoralCommittee } from './model/DoctoralCommitteeTypes';

interface DoctoralCommitteeViewProps {
  doctoralCommittee: DoctoralCommittee;
}

export function DoctoralCommitteeView(props: DoctoralCommitteeViewProps) {
  const { t } = useTranslation();
  const { doctoralCommittee } = props;
  const { type, startYear, endYear, year, candidateName, doctoralSchoolName, coordinatorName, authors } =
    doctoralCommittee;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{candidateName}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <DoctoralCommitteeDeleteButton doctoralCommitteeId={doctoralCommittee.id} />
            </Group>
          </Flex>
          <Text>
            {t('doctoralCommittees.form.fields.doctoralSchoolName')}: {doctoralSchoolName}
          </Text>
          <Text>
            {t('doctoralCommittees.form.fields.coordinatorName')}: {coordinatorName}
          </Text>
          <Group>
            <Pill>{t(`doctoralCommittees.typeEnum.${type}`)}</Pill>
            {type === 'GUIDANCE' ? (
              <Text
                c="dimmed"
                size="xs"
              >
                {startYear} - {endYear}
              </Text>
            ) : (
              <Text
                c="dimmed"
                size="xs"
              >
                {year}
              </Text>
            )}
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <DoctoralCommitteeProofAction
        doctoralCommitteeId={doctoralCommittee.id}
        authors={authors}
      />
      <DoctoralCommitteeValidationAction doctoralCommitteeId={doctoralCommittee.id} />
      <DoctoralCommitteeValidationHistory doctoralCommitteeId={doctoralCommittee.id} />
    </Stack>
  );
}
